import { Directive, ElementRef, effect, inject, input } from '@angular/core';

@Directive({
  selector: '[autoFocus]',
  standalone: true
})
export class AutoFocusDirective {
  private el = inject(ElementRef);

  readonly shouldFocus = input<boolean>(false);

  constructor() {
    effect(() => {
      if (this.shouldFocus()) {
        // Use setTimeout to ensure the element is rendered
        setTimeout(() => {
          this.el.nativeElement.focus();
        }, 0);
      }
    });
  }
}
